import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'p-form-wrapper',
  templateUrl: './p-form-wrapper.component.html',
  styleUrls: ['./p-form-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PFormWrapperComponent {
  @Input() titleWrapper!: string;
}
